const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  nba: {
    label: 'NBA',
    logo: `${TGB_ASSETS_URL}/logos/nba/nba.svg`,
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  nfl: {
    label: 'NFL',
    logo: `${TGB_ASSETS_URL}/logos/nfl/nfl.svg`,
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  nhl: {
    label: 'NHL',
    logo: `${TGB_ASSETS_URL}/logos/nhl/nhl.svg`,
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  mlb: {
    label: 'MLB',
    logo: `${TGB_ASSETS_URL}/logos/mlb/mlb.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  mls: {
    label: 'MLS',
    logo: `${TGB_ASSETS_URL}/logos/mls/mls-logo.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  fifa_world_cup: {
    label: 'FIFA World Cup',
    logo: `${TGB_ASSETS_URL}/logos/fifa/fifa.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  epl: {
    label: 'Premier League',
    logo: `${TGB_ASSETS_URL}/logos/epl/epl.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  /* nwsl: {
    label: 'NWSL',
    logo: `${TGB_ASSETS_URL}/logos/nwsl/nwsl.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  }, */
  nascar_cup: {
    label: 'NASCAR Cup Series',
    logo: `${TGB_ASSETS_URL}/logos/nascar/nascar_cup.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'NASCAR',
    participantType: 'players_pool',
    statSelectorDefaults: {
      statType: 'player',
      statPeriod: 'game',
    },
  },
  nascar_truck: {
    label: 'NASCAR Craftsman Truck Series',
    logo: `${TGB_ASSETS_URL}/logos/nascar/nascar_truck.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'NASCAR',
    participantType: 'players_pool',
    statSelectorDefaults: {
      statType: 'player',
      statPeriod: 'game',
    },
  },
  nascar_oaps: {
    label: 'NASCAR O\'Reilly Auto Parts Series',
    logo: `${TGB_ASSETS_URL}/logos/nascar/nascar_oaps.svg`,
    statsProvider: 'sportsstack',
    poweredByLabel: 'NASCAR',
    participantType: 'players_pool',
    statSelectorDefaults: {
      statType: 'player',
      statPeriod: 'game',
    },
  },
  ncaafb: {
    label: 'NCAA Football',
    logo: `${TGB_ASSETS_URL}/logos/ncaafb/ncaa-football.avif`,
    additionalFilters: ['conference'],
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  ncaamb: {
    label: 'NCAA Men\'s Basketball',
    logo: `${TGB_ASSETS_URL}/logos/ncaamb/ncaa-basketball-men.avif`,
    additionalFilters: ['conference'],
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
  ncaawb: {
    label: 'NCAA Women\'s Basketball',
    logo: `${TGB_ASSETS_URL}/logos/ncaawb/ncaa-basketball-women.avif`,
    additionalFilters: ['conference'],
    statsProvider: 'sportradar',
    poweredByLabel: 'Sportradar',
    participantType: 'team_v_team',
  },
};
